'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024$002dMeal$00241 from "./samples.-Enum-Sample$package$-Meal$1.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$Meal$3$() {
}
export { $c_Lsamples_EnumSample$package$Meal$3$ as $c_Lsamples_EnumSample$package$Meal$3$ };
$p = $c_Lsamples_EnumSample$package$Meal$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$Meal$3$;
/** @constructor */
function $h_Lsamples_EnumSample$package$Meal$3$() {
}
export { $h_Lsamples_EnumSample$package$Meal$3$ as $h_Lsamples_EnumSample$package$Meal$3$ };
$h_Lsamples_EnumSample$package$Meal$3$.prototype = $p;
$p.b = (function() {
  return "Meal";
});
$p.Uu = (function(x$0) {
  return new $j_samples$002e$002dEnum$002dSample$0024package$0024$002dMeal$00241.$c_Lsamples_EnumSample$package$Meal$1(x$0.g(0), x$0.g(1));
});
$p.y = (function(p) {
  return this.Uu(p);
});
var $d_Lsamples_EnumSample$package$Meal$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$Meal$3$, "samples.EnumSample$package$Meal$3$", ({
  pc: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_EnumSample$package$Meal$3$ as $d_Lsamples_EnumSample$package$Meal$3$ };
